import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Todos los días la misma pregunta: "¿qué comemos?"', 'Siempre las mismas 5 comidas rotadas', 'Delivery de emergencia que vacía el bolsillo', 'Heladera llena pero "no hay nada para comer"', 'Fin de semana perdido pensando en la semana', 'Recetas de Instagram con ingredientes imposibles'];
export const PainPointsSection = () => {
  return <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-179">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-10" data-id="element-180">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-181">
          💣 ¿TE SUENA CONOCIDO?
        </h2>
        <div className="w-24 h-1 bg-red-500 mx-auto rounded-full mb-8" data-id="element-182"></div>
      </motion.div>

      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8 mb-8" data-id="element-183">
        <ul className="space-y-4" data-id="element-184">
          {painPoints.map((point, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3" data-id="element-185">
              <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-186" />
              <span className="text-lg md:text-xl text-gray-300 font-medium" data-id="element-187">
                {point}
              </span>
            </motion.li>)}
        </ul>
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="text-center bg-orange-900/20 border-2 border-orange-500 rounded-xl p-6" data-id="element-188">
        <p className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-189">
          No es falta de ganas.{' '}
          <span className="text-orange-500 block md:inline mt-2 md:mt-0" data-id="element-190">
            Es falta de un sistema.
          </span>
        </p>
      </motion.div>
    </section>;
};